<template>
  <el-date-picker :size="size" class="width-xxx" type="month" placeholder="选择月"
                  :value="cValue" @input="handleInput" @change="emitChange" value-format="yyyy-MM"
  >
  </el-date-picker>
</template>

<script>
import {optionalValueMixin} from '../../../utils/optional-value'

export default {
  name: 'input-date-month',
  mixins: [optionalValueMixin],
  props: {
    size: {
      type: String,
      default: 'mini'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/inputs/input-date-month.vue